export const EMPLOYMENT_TYPES = [
  "FULL_TIME",
  "PART_TIME",
  "CASUAL",
  "SEASONAL",
] as const;

export type EmploymentType = (typeof EMPLOYMENT_TYPES)[number];

export const EMPLOYMENT_TYPE_LABEL_VI: Record<EmploymentType, string> = {
  FULL_TIME: "Toàn thời gian",
  PART_TIME: "Bán thời gian",
  CASUAL: "Theo ngày / Linh hoạt",
  SEASONAL: "Thời vụ",
};

export const EMPLOYMENT_TYPE_LABEL_VI_SHORT: Record<EmploymentType, string> = {
  FULL_TIME: "Full-time",
  PART_TIME: "Part-time",
  CASUAL: "Casual",
  SEASONAL: "Thời vụ",
};

export const SALARY_TYPES = [
  "PER_HOUR",
  "PER_SHIFT",
  "PER_DAY",
  "PER_MONTH",
] as const;

export type SalaryType = (typeof SALARY_TYPES)[number];

export const SALARY_TYPE_LABEL_VI: Record<SalaryType, string> = {
  PER_HOUR: "/giờ",
  PER_SHIFT: "/ca",
  PER_DAY: "/ngày",
  PER_MONTH: "/tháng",
};

export const AVAILABLE_FROM = [
  "IMMEDIATE",
  "IN_1_WEEK",
  "IN_2_WEEKS",
  "FLEXIBLE",
] as const;

export type AvailableFrom = (typeof AVAILABLE_FROM)[number];

export const AVAILABLE_FROM_LABEL_VI: Record<AvailableFrom, string> = {
  IMMEDIATE: "Ngay",
  IN_1_WEEK: "Trong 1 tuần",
  IN_2_WEEKS: "Trong 2 tuần",
  FLEXIBLE: "Linh hoạt",
};

export const EXPERIENCE_DURATIONS = [
  "LESS_3_MONTHS",
  "M3_TO_6",
  "M6_TO_12",
  "Y1_TO_2",
  "Y2_PLUS",
] as const;

export type ExperienceDuration = (typeof EXPERIENCE_DURATIONS)[number];

export const EXPERIENCE_DURATION_LABEL_VI: Record<ExperienceDuration, string> =
  {
    LESS_3_MONTHS: "Dưới 3 tháng",
    M3_TO_6: "3 – 6 tháng",
    M6_TO_12: "6 – 12 tháng",
    Y1_TO_2: "1 – 2 năm",
    Y2_PLUS: "Trên 2 năm",
  };

// Numeric ordering for "min experience" comparison
export const EXPERIENCE_DURATION_ORDER: Record<ExperienceDuration, number> = {
  LESS_3_MONTHS: 0,
  M3_TO_6: 1,
  M6_TO_12: 2,
  Y1_TO_2: 3,
  Y2_PLUS: 4,
};
